import Label from "./Label";
import Description from "./Description";

export default function FieldWrapper({
    children,
    width,
    containerClass = "grid grid-cols-1 lg:grid-cols-2 lg:gap-10 gap-4",
    verticalContainerClass,
    label,
    help,
    description,
    direction = "horizontal", // vertical
    type,
    lableClass,
    fieldsClass = "lg:justify-self-end lg:self-center",
}) {
    return (
        <>
            {direction === "horizontal" && (
                <div className={containerClass}>
                    <div className={lableClass}>
                        <Label label={label} help={help} />
                        <Description
                            description={description}
                            containerClass="text-xs text-gray-500 mt-1"
                        />
                    </div>
                    <div
                        className={`fields-wrapper max-wp:!w-auto ${
                            type || ""
                        } ${fieldsClass}`.trim()}
                        style={
                            width
                                ? {
                                      width: `${Number(width) * 0.25}rem`,
                                      maxWidth: "100%",
                                  }
                                : undefined
                        }
                    >
                        {children}
                    </div>
                </div>
            )}

            {direction === "vertical" && (
                <div className={verticalContainerClass}>
                    <Label
                        containerClass={`${
                            lableClass ? lableClass : "mb-2"
                        }`.trim()}
                        label={label}
                        help={help}
                    />
                    <div
                        className={`fields-wrapper max-wp:!w-auto ${
                            type ? type : ""
                        } ${fieldsClass}`.trim()}
                        style={
                            width
                                ? {
                                      width: `${Number(width) * 0.25}rem`,
                                      maxWidth: "100%",
                                  }
                                : undefined
                        }
                    >
                        {children}
                    </div>
                    <Description description={description} />
                </div>
            )}
        </>
    );
}
